import { jsx as _jsx } from "react/jsx-runtime";
import { useBrand } from "@aviv-unified-frontend/runtime/brand";
import { AirshipLoader as Airship } from "@aviv-trak/airship";
import { BRAND_CONFIGURATION } from "../../../configs/brands";
import { useShouldInitOverlay } from "../OverlayOrchestrator";
import { useConsentServiceStatus } from "../../utils/consentManagement";
const sdkSrc = "/assets/mir/airship/ua-sdk.min.js";
const workerUrl = "/airship-push-worker.js";
export const AirshipLoader = () => {
    const config = BRAND_CONFIGURATION.airship;
    const { id } = useBrand();
    const { appKey, token, vapidPublicKey, trackingConsentId, pushConsentId } = config ?? {};
    const hasTrackingConsent = useConsentServiceStatus(trackingConsentId);
    const hasPushConsent = useConsentServiceStatus(pushConsentId);
    const shouldInit = useShouldInitOverlay("airship");
    if (!appKey || !token || !vapidPublicKey || !shouldInit)
        return null;
    return (_jsx(Airship, { appKey: appKey, brand: id, sdkSrc: sdkSrc, workerUrl: workerUrl, hasPushConsent: hasPushConsent, hasTrackingConsent: hasTrackingConsent, token: token, vapidPublicKey: vapidPublicKey, businessType: BRAND_CONFIGURATION.type.toUpperCase() }));
};
